import { constantRouterMap } from "@/config/router.config";
import { icons } from "@/core/icons";

import { findByUser } from "@/api/system/menu";
import { findByUserId } from "@/api/system/authentication";

import storage from "store";
import { USER, AUTH } from "@/store/mutation-types";

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission(permission, route) {
  if (route.meta && route.meta.permission) {
    let flag = false;
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.includes(permission[i]);
      if (flag) {
        return true;
      }
    }
    return false;
  }
  return true;
}

/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(roles.id);
  } else {
    return true;
  }
}

// eslint-disable-next-line
function filterAsyncRouter(constantRouterMap, roles) {
  const accessedRouters = constantRouterMap.filter(route => {
    if (hasPermission(roles.permissionList, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles);
      }
      return true;
    }
    return false;
  });
  // console.log("accessedRouters", accessedRouters);
  return accessedRouters;
}

function generateChildRouters(data) {
  const Routes = data.map(item => {
    // 前端组件component
    let componentPath = item.component;
    item.component = () => import(`@/${componentPath}`);
    item.hidden = item.hideInMenu === "A" ? false : true;
    // 图标icon
    try {
      item.meta.icon =
        icons[`${item.meta.icon}`] || item.meta.icon || undefined;
    } catch (e) {
      item.meta.icon = item.meta.icon || undefined;
    }
    if (item.children && item.children.length > 0) {
      item.children = [...generateChildRouters(item.children)];
    } else {
      item.children = null;
    }
    return item;
  });
  return Routes;
}

// 生成首页路由
export function generateIndexRouter(data) {
  let indexRouter = [
    {
      path: "/",
      name: "index",
      component: () => import("@/layouts/BasicLayout"),
      meta: { title: "首页" },
      redirect: data[0].path || null,
      children: [...generateChildRouters(data)]
    },
    {
      path: "*",
      redirect: "/404",
      hidden: true
    }
  ];
  return indexRouter;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }) {
      return new Promise(resolve => {
        findByUser().then(res => {
          const routers = generateIndexRouter(res.result);
          commit("SET_ROUTERS", routers);
          resolve();
        });
      });
    },
    GenerateAuths() {
      return new Promise(resolve => {
        let user = storage.get(USER);
        findByUserId({ userId: user.userid }).then(res => {
          const auth = res.result;
          storage.set(AUTH, auth, 24 * 60 * 60 * 1000);
          resolve();
        });
      });
    }
  }
};

export default permission;
